import { render } from "./LoadingOverlay.vue?vue&type=template&id=8ef73678&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=8ef73678&scoped=true&lang=css"

import exportComponent from "C:\\dev\\Lipa-Digital-Labs\\dev\\Potsmunter\\mpt-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef73678"]])

export default __exports__